export const colors = {
    primary: '#0072b1',
    secondary: '#004960',
    grey: 'rgb(211, 211, 211)',
    red: '#ad3838'
};